var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('notifications'),_c('side-bar',[_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
            name: '风电行业大数据报告',
            path: '/dataReport',
            icon: 'ni ni-tv-2 text-primary',
          }}}),_c('sidebar-item',{attrs:{"link":{
              name: '实时功率预测',
              path: '/realTimePre',
              icon: 'ni ni-planet text-blue'
              }}}),_c('sidebar-item',{attrs:{"link":{
                    name: '地图定点预测',
                    path: '/locationPre',
                    icon: 'ni ni-pin-3 text-orange'
                  }}}),_c('sidebar-item',{attrs:{"link":{
                    name: '历史数据分析',
                    path: '/historyData',
                    icon: 'ni ni-calendar-grid-58 text-purple'
                  }}}),_c('sidebar-item',{attrs:{"link":{
                name: '给小朋友的风电读物',
                path: '/guideForKid',
                icon: 'ni ni-key-25 text-pink'
              }}})],1),_c('template',{slot:"links-after"},[_c('hr',{staticClass:"my-3"}),_c('h6',{staticClass:"navbar-heading p-0 text-muted"},[_vm._v("友情链接")]),_c('b-nav',{staticClass:"navbar-nav mb-md-3"},[_c('b-nav-item',{attrs:{"href":"https://www.in-en.com/"}},[_c('i',{staticClass:"ni ni-spaceship"}),_c('b-nav-text',{staticClass:"p-0"},[_vm._v("国际能源网")])],1),_c('b-nav-item',{attrs:{"href":"https://wind.in-en.com/"}},[_c('i',{staticClass:"ni ni-palette"}),_c('b-nav-text',{staticClass:"p-0"},[_vm._v("国际风力发电网")])],1),_c('b-nav-item',{attrs:{"href":"https://power.in-en.com/"}},[_c('i',{staticClass:"ni ni-ui-04"}),_c('b-nav-text',{staticClass:"p-0"},[_vm._v("国际电力网")])],1)],1)],1)],2),_c('div',{staticClass:"main-content"},[_c('dashboard-navbar',{attrs:{"type":_vm.$route.meta.navbarType}}),_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('router-view')],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }